import React from 'react'
import PropTypes from 'prop-types'
import { Navigate as Redirect } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, get, isNil, some, omit, isObject } from 'lodash'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/Users'
import carrierBrandActions from '../../actions/CarrierBrands'
import platformActions from '../../actions/Platforms'
import { createFlashMessage } from '../../actions/FlashMessages'
import CarrierUserForm from './CarrierUserForm'
import alert from '../../alert'

export class CarrierUserEdit extends Component {
  static propTypes = {
    params: PropTypes.object,
    update: PropTypes.func.isRequired,
    show: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    showReset: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    attributes: PropTypes.object,
    updated: PropTypes.bool.isRequired,
    createFlashMessage: PropTypes.func.isRequired,
    carrierBrands: PropTypes.array,
    indexCarrierBrands: PropTypes.func.isRequired,
    resetCarrierBrands: PropTypes.func.isRequired,
    platforms: PropTypes.array,
    indexPlatforms: PropTypes.func.isRequired,
    resetPlatforms: PropTypes.func.isRequired,
    platformsRequestInProgress: PropTypes.bool.isRequired,
    carrierBrandsRequestInProgress: PropTypes.bool.isRequired
  }

  componentDidMount() {
    this.props.show(this.id)
  }

  componentWillUnmount() {
    this.props.reset()
    this.props.showReset()
  }

  get id() {
    return this.props.params.id
  }

  get initialAttributes() {
    const newAttributes = cloneDeep(omit(this.props.attributes, ['roles', 'user_roles']))

    newAttributes.carrier_brands = newAttributes.carrier_brands.map((userCarrierBrand) => ({
      label: userCarrierBrand.name,
      value: userCarrierBrand.id
    }))

    return newAttributes
  }

  handleSubmit = (values) => {
    this.props
      .update(this.id, this.translateValues(values))
      .then(({ id }) => {
        this.props.createFlashMessage('Updated user', { id: parseInt(id, 10), tag: 'index' })
      })
  }

  translateValues = (values) => {
    const newValues = cloneDeep(values)

    if (!isNil(newValues.carrier_brands)) {
      const changes = !isObject(newValues.carrier_brands[0])
      const existingUserCarrierBrands = get(this.props.attributes, 'carrier_brands', [])

      if (!changes) { newValues.carrier_brands = newValues.carrier_brands.map((ucb) => (ucb.value)) }

      newValues.carrier_brands = existingUserCarrierBrands.map((v) => {
        const exists = newValues.carrier_brands.includes(v.id)
        if (!exists) { return { carrier_brand_id: v.id, _destroy: true } }

        return { carrier_brand_id: v.id }
      })

      if (changes) {
        const newUserCarrierBrands = values.carrier_brands
          .filter((v) => !some(existingUserCarrierBrands, { id: v }))
          .map((v) => ({ carrier_brand_id: v }))

        newValues.carrier_brands = newValues.carrier_brands.concat(newUserCarrierBrands)
      }
    }

    return newValues
  }

  redirect(path) {
    return <Redirect replace to={path} />
  }

  render() {
    const {
      generalError,
      resourceErrors,
      requestInProgress,
      attributes,
      updated
    } = this.props

    if (!isNil(generalError)) {
      alert(generalError)
    }

    if (!isNil(this.destroyError)) {
      alert(this.destroyError)
    }

    if (isNil(attributes)) {
      return null
    }

    if (updated) {
      return this.redirect('/carrier_users')
    }

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    let carrierBrands = cloneDeep(this.props.carrierBrands)

    if (isNil(carrierBrands) && !this.props.carrierBrandsRequestInProgress) {
      carrierBrands = attributes.carrier_brands
    }

    let platforms = cloneDeep(this.props.platforms)

    if (isNil(platforms) && !this.props.platformsRequestInProgress) {
      platforms = attributes.cvt_platforms
    }

    return (
      <div className="content">
        <h2>Edit Carrier User</h2>
        <div>
          <CarrierUserForm
            handleSubmit={this.handleSubmit}
            errors={errors}
            requestInProgress={requestInProgress}
            submitLabel="Update User"
            carrierBrands={carrierBrands}
            resetCarrierBrands={this.props.resetCarrierBrands}
            carrierBrandsRequestInProgress={this.props.carrierBrandsRequestInProgress}
            indexCarrierBrands={this.props.indexCarrierBrands}
            platforms={platforms}
            resetPlatforms={this.props.resetPlatforms}
            platformsRequestInProgress={this.props.platformsRequestInProgress}
            indexPlatforms={this.props.indexPlatforms}
            initialValues={this.initialAttributes}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.users.update
  const showSlice = state.users.show
  const carrierBrandsSlice = state.carrierBrands.index
  const platformsSlice = state.platforms.index

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    requestInProgress: slice.requestInProgress,
    attributes: showSlice.attributes,
    id: slice.id,
    updated: slice.updated,

    carrierBrands: carrierBrandsSlice.records,
    carrierBrandsRequestInProgress: carrierBrandsSlice.requestInProgress,

    platforms: platformsSlice.records,
    platformsRequestInProgress: platformsSlice.requestInProgress
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  update: actions.update.main,
  reset: actions.update.reset,

  show: actions.show.main,
  showReset: actions.show.reset,

  indexCarrierBrands: carrierBrandActions.index.main,
  resetCarrierBrands: carrierBrandActions.index.reset,

  indexPlatforms: platformActions.index.main,
  resetPlatforms: platformActions.index.reset,

  createFlashMessage
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CarrierUserEdit))
